import React from 'react';
import PropTypes from 'prop-types';

import PageHeader from 'components/project/page_header';

export default function CompaniesPageHeader({ onAddCompany }) {
  const actions = (
    <PageHeader.Actions>
      <button
        className="btn btn-create pull-right"
        name="btn-add-company"
        onClick={(e) => {
          e.preventDefault();
          if (onAddCompany) onAddCompany();
        }}
      >
        Add Company
      </button>
    </PageHeader.Actions>
  );

  return (
    <PageHeader actions={actions} title="Companies" />
  );
}

CompaniesPageHeader.propTypes = {
  onAddCompany: PropTypes.func
};
